import PollFormState from './PollFormState';
import PollListState from './PollListState';
import PollState from './PollState';
import PollGroupFormState from './PollGroupFormState';
import PollGroupListState from './PollGroupListState';

export const states = {
  PollFormState,
  PollListState,
  PollState,
  PollGroupFormState,
  PollGroupListState,
};
